import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import * as SvgIcons from 'components/Material/SvgIcons';
import { history } from 'helpers';

export default class LinkList extends Component {
  static propTypes = {
    links: PropTypes.array,
    onClickLink: PropTypes.func
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  go = (link, event) => {
    const { onClickLink, username } = this.props;
    const href = `/about/${username}${link.href}`;
    event.preventDefault();
    event.stopPropagation();
    onClickLink && onClickLink(username, link.href);
    // history.push(href);
  };

  render() {
    const { username } = this.props;
    if (this.props.links.length > 0) {
      let { className, ...other } = this.props;
      let links = this.props.links.map((link, index) => {
        const text = this.context.getIntlMessage(link.text);

        return (
          <span
            key={index}
            className="link-list-link"
            onTouchTap={this.go.bind(this, link)}
          >
            {text}
            <SvgIcons.NavigationChevronRight />
          </span>
        );
      });
      return (
        <div className={classNames('link-list', className)} {...other}>
          {links}
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/LinkList.js